import BaseEventPayload from './BaseEventPayload';

export default class UploadEventPayload extends BaseEventPayload {
  constructor(data = {}, parentEventLog) {
    super(UploadEventPayload, data, parentEventLog);
    this.fileName = data.fileName;
  }
}
